module.exports = __webpack_public_path__ + "media/src/images/icons/file-a299483bee3d4f20dca729644dfcf417.svg";